// Hides the secret menu and handles the show/hide logic for UTM parameters
function hideSecretMenu() {
  const hiddenGlobalMenu = document
    .querySelector('[data-hidden-menu]')
    ?.getAttribute('data-hidden-menu');
  const hiddenCatNavMenu = document
    .querySelector('[data-hidden-cat-nav-menu]')
    ?.getAttribute('data-hidden-cat-nav-menu');

  const showHiddenMenu = sessionStorage.getItem('showHiddenMenu');
  if (hiddenGlobalMenu != null && hiddenCatNavMenu != null) {
    [...document.querySelectorAll('.subLink')].forEach(function (item) {
      //covers cases where the cat nav + global nav menu items to hide have the same id
      //and when they have different ids
      if (
        item.id == hiddenGlobalMenu ||
        item.id == hiddenCatNavMenu ||
        hiddenCatNavMenu.includes(item.id)
      ) {
        //hide cat nav item if its id is set in admin
        item.classList.add('hidden-menu');
      }
      if (showHiddenMenu) {
        //show cat nav item, if user came from correct UTM link
        item.classList.remove('hidden-menu');
      }
    });
  }
}

// Focus search field when search icon is clicked
function focusSearchField() {
  const searchIcon = document.querySelector('.search-icon');
  const searchField = document.querySelector(
    '#search-popdown .live-search-form .live-search-form-field',
  );

  if (searchIcon && searchField) {
    searchIcon.addEventListener('click', () => {
      searchField.focus();
    });
  }
}
document.addEventListener('DOMContentLoaded', debounce(focusSearchField));

function debounce(func, wait = 10, immediate = true) {
  let timeout;
  return function () {
    let context = this,
      args = arguments;
    let later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    let callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

// validate this is not used in other places then remove
function handleFloatingFooterContent() {
  document.addEventListener('theme:scroll:lock', function () {
    document.dispatchEvent(new CustomEvent('chat:hide', { bubbles: true }));
  });

  document.addEventListener('theme:scroll:unlock', function () {
    document.dispatchEvent(new CustomEvent('chat:show', { bubbles: true }));
  });

  document.addEventListener('chat:hide', function () {
    var chat = document.getElementById('gorgias-chat-container');
    if (chat) {
      chat.style.display = 'none';
    }
    var modal = document.getElementById('attentive_creative');
    if (modal) {
      modal.style.display = 'none';
    }
    var cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      cookieBanner.classList.add('hidden-bar');
    }
    
    var klaviyoFavorite = document.querySelector('[data-floating-ui-portal]')
    if (klaviyoFavorite) {
      klaviyoFavorite.style.display = 'none';
    }
  });

  document.addEventListener('chat:show', function () {
    var chat = document.getElementById('gorgias-chat-container');
    chat.style.display = 'block';
    var modal = document.getElementById('attentive_creative');
    if (modal) {
      modal.style.display = 'block';
    }
    var cookieBanner = document.getElementById('site-cb-footer');
    if (cookieBanner) {
      //console.log('cookieBanner', cookieBanner);
      //cookieBanner.classList.remove('hidden-bar');
    }
    var klaviyoFavorite = document.querySelector('[data-floating-ui-portal]')
    if (klaviyoFavorite) {
      klaviyoFavorite.style.display = 'block';
    }
  });
}
handleFloatingFooterContent();

function handleHamburgerMenu() {
  // Lock scroll when mobile menu nav drawer is open
  var hamburgerMobileMenuOpen = document.querySelector(
    '.header__mobile__button',
  );
  var mobileMenuClose = document.querySelector('.drawer__close');
  var bodyEl = document.body;

  hamburgerMobileMenuOpen?.addEventListener('click', bodyFixed);

  mobileMenuClose?.addEventListener('click', bodyFixed);

  function bodyFixed() {
    bodyEl.classList.toggle('fixed-position');
  }
}
handleHamburgerMenu();

(function () {

  // check if the secret menu content exists and handle the show/hide logic
  const secretMenuContent = document.querySelector('[data-hidden-menu]');
  if (secretMenuContent != null) {
    secretMenuContent.addEventListener('DOMContentLoaded', hideSecretMenu());
  }
})();
